module.exports = __webpack_public_path__ + "img/garantia.fb3a080a.png";